/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import FormikInput from './formik/FormikInput';
import FormikDateTimePicker from './formik/FormikDateTimePicker';

const UserInfoComponent = ({
    values,
    name,
    readOnly,
}) => (
    <>
        <div className="form-row">
            <div className="form-group col-md-6">
                <label>First Name</label>
                <FormikInput
                    readOnly={readOnly}
                    name={`${name ? `${name}.` : ''}firstName`}
                    type="text"
                    className="form-control"
                />
            </div>
            <div className="form-group col-md-6">
                <label>Last Name</label>
                <FormikInput
                    readOnly={readOnly}
                    name={`${name ? `${name}.` : ''}lastName`}
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-row">
            <div className="form-group col-md-6">
                <label>Father First Name</label>
                <FormikInput
                    readOnly={readOnly}
                    name={`${name ? `${name}.` : ''}fatherFirstName`}
                    type="text"
                    className="form-control"
                />
            </div>
            <div className="form-group col-md-6">
                <label>Father Last Name</label>
                <FormikInput
                    readOnly={readOnly}
                    name={`${name ? `${name}.` : ''}fatherLastName`}
                    type="text"
                    className="form-control"
                />
            </div>
        </div>

        <div className="form-row">
            <div className="form-group col-md-4">
                <label>Email</label>
                <FormikInput
                    readOnly={readOnly}
                    name={`${name ? `${name}.` : ''}email`}
                    type="text"
                    className="form-control"
                />
            </div>
            <div className="form-group col-md-4">
                <label>Phone</label>
                <FormikInput
                    readOnly={readOnly}
                    name={`${name ? `${name}.` : ''}phone`}
                    type="text"
                    className="form-control"
                />
            </div>

            <div className="form-group col-md-4">
                <label>
                    D.O.B
                    {' '}
                    <small>yyyy-mm-dd</small>
                </label>
                <FormikDateTimePicker
                    name={`${name ? `${name}.` : ''}dob`}
                    value={values.dob}
                    readOnly={readOnly}
                    className="form-control"
                    disableClock
                    format="dd-MM-y"
                />
            </div>
        </div>
    </>
);

UserInfoComponent.propTypes = {
    values: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        fatherFirstName: PropTypes.string,
        fatherLastName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        dob: PropTypes.any,
    }),
    name: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
};

UserInfoComponent.defaultProps = {
    values: {
        dob: '',
    },
    readOnly: false,
};

export default UserInfoComponent;
